<template>
  <div class="col-md-4 pd-5">
    <div class="card p-1 height-235 mb-0">
      <div class="d-flex justify-content-between">
        <span>{{ statisticsItem[itemKey].name }}</span>
        <span @click="navigate(statisticsItem[itemKey].url)" class="cursor-pointer">See All</span>
      </div>
      <hr>
      <p class="text-center center-position" v-if="statisticsItem[itemKey].data.length == 0">Not data available</p>
      <table v-else class="table table-sm table-striped">
        <thead>
        </thead>
        <tbody>
        <tr v-for="(list, key) in  statisticsItem[itemKey].data">
          <th scope="row">{{ ++key }}</th>
          <td class="text-start">
            <div class="cut-text">
              {{ list.name }}
            </div>
          </td>
          <td class="text-end">{{ commaFormat(list.amount) }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import useDate from "@/services/utils/day";
import figureFormatter from "@/services/utils/figureFormatter";

const {firstDateOfMonth, lastDateOfMonth} = useDate()

const router = useRouter()
const route = useRoute()
const {commaFormat} = figureFormatter()

defineProps({
  statisticsItem: Object,
  page: Object,
  itemKey: String
})

function navigate(url) {
  router.push({name: url, params: route.params, query: {start: firstDateOfMonth, end: lastDateOfMonth}})
}

</script>
